import PageTransition from "@/components/ui/PageTransition";
import Spinner from "@/components/ui/spinner";
import React from "react";

interface PendingScreenProps {
	title: string | React.ReactNode;
	description: string | React.ReactNode;
	onClose?: () => void;
	children: React.ReactNode;
}

const PendingScreen: React.FC<PendingScreenProps> = ({
	title,
	description,
	onClose,
	children,
}) => {
	return (
		<PageTransition>
			<div className="text-center max-w-lg mx-auto">
				{/* No XIcon for pending, but you can add a close button if needed */}
				{onClose && (
					<button
						type="button"
						className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
						onClick={onClose}
						aria-label="Close"
					>
						×
					</button>
				)}
				<div className="max-w-64 mx-auto flex justify-center items-center h-32">
					<Spinner className="w-24 h-24" />
				</div>
				<div className="w-full text-center">
					<h1 className="text-4xl font-bold text-textDark">{title}</h1>
					<p className="pt-3 text-sm font-medium text-textDark pb-9">
						{description}
					</p>
				</div>
				<div className="mt-6">{children}</div>
			</div>
		</PageTransition>
	);
};

export default PendingScreen;
